<template>
  <!-- NOTIFICATIONS -->
  <div v-show="rendred" class="cursor-pointer">
      <div id="chat_pop_app" @click="chatPopIsShowed = !chatPopIsShowed" class="p-1 rounded-full flex justify-center items-center relative" style="background:#5b97fc1a" >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
          <div v-show="messagesCount>0" class="absolute rounded-full bg-danger pulse_effect"  >
            {{messagesCount}}
          </div>
      </div>
    <ChatPop :warehouse="warehouse" v-show="rendred && chatPopIsShowed" :store="{name:'manager'}" :chatPopIsShowed="chatPopIsShowed" v-on:showImg="showImg($event)" v-on:unreadedMessages="unreadedMessages($event)"  v-on:hidepop="chatPopIsShowed=false" v-on:rendred="rendred=true"/>
   <!-- <div v-if="imageFull" class="image-full">
        <div @click="imageFull=null" class="back-box"></div>
        <div class="img">
          <div class="close-icon abs-ico" @click="imageFull=null">
            <div class="bar"></div>
            <div class="bar"></div>
          </div>
          <img :src="imageFull" alt="">
        </div>
    </div> -->
  </div>
</template>

<script>
import ChatPop from "./chatPop.vue";
export default {
  components: {ChatPop},
  props:{warehouse:{type:Object}},
  data() {
    return {
      chatPopIsShowed: false,
      rendred: true,
      messagesCount: 0,
      imageFull: null,
      curentStore: null,
    };
  },
  mounted() {
     this.resizePopUp();
  },
  watch: {
    chatPopIsShowed(value) {
      if (value) this.styling();
    },
  },
  methods: {
    showImg(src) {
      this.imageFull = src;
    },
    unreadedMessages(count) {
      this.messagesCount = count;
    },
    closeImg() {
      this.imageFull = null;
    },
    resizePopUp() {
      let vm = this;
      window.addEventListener(
        "resize",
        function(e) {
          vm.chatPopIsShowed = false;
          vm.styling();
        },
        true
      );
    },
    styling() {
      let chatc = document.getElementById("chat_container");
      let vp = document.getElementById("chat_pop_app").getBoundingClientRect();
      //  console.log("resizePopUp",document.documentElement.clientWidth);
      chatc.style.top = `${vp.top + 45}px`;
      chatc.style.transform = "translateX(-50%)";
      if (document.documentElement.clientWidth > 1000) {
        chatc.style.left = `${vp.left}px`;
      } else {
        chatc.style.left = "50%";
      }
    },
  },
};
</script>
<style scoped>
.cursor-pointer{
  color: #3d3d3d;
}
.pulse_effect{
      top: -7px;
    right: -8px;
    width: 18px;
    height: 18px;
    BACKGROUND: #55a55b;
    display: flex;
    align-items: center;
    color: #ffff;
    font-size: 14px;
    justify-content: center;
    font-weight: bold;
}
</style>
